import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ExemptionPolicyDetailFields from './ExemptionPolicyDetailFields'

export const ExemptionPolicyDetailPolicyEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <ExemptionPolicyDetailFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default ExemptionPolicyDetailPolicyEdit
